import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { required, SelectInput, TextInput, maxLength } from 'react-admin';
import { Grid, makeStyles, Typography } from '@material-ui/core/';

import FileField from '../../core/components/forked/field/FileField';
import FileInput from '../../core/components/forked/input/FileInput';
import { matchingFields, typeChoices } from './SplitMethodTypeLookups';

const StyledFileInput = withStyles({
  dropZone: {
    background: '#f5f5f5',
    border: '1px dashed #E0E0E0',
    marginTop: '-4px'
  },
  removeButton: {
    textAlign: 'center',
    padding: '.5rem'
  }
})(FileInput);

const useStyles = makeStyles({
  headerContainer: {
    paddingTop: '0px !important'
  },
  browseLink: {
    textDecoration: 'underline',
    color: '#2962ff'
  }
});

const SplitMethodSummary = () => {
  const classes = useStyles();

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} className={classes.headerContainer}>
        <Typography variant="h5">Split Method Details</Typography>
      </Grid>
      <Grid item xs={12} sm={12} md={6} lg={4}>
        <TextInput
          source="name"
          variant="standard"
          validate={[required(), maxLength(60, 'ra.validation.maxLength')]}
          label="Split Method Name"
          options={{ autoComplete: 'off' }}
        />
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <SelectInput
            source="externalId"
            variant="standard"
            label="Matching Field"
            validate={[required()]}
            choices={matchingFields}
            options={{ autoComplete: 'off' }}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <SelectInput
            source="type"
            label="Split Type"
            variant="standard"
            choices={typeChoices}
            optionValue="code"
            options={{ autoComplete: 'off' }}
          />
        </Grid>
      </Grid>
      <Grid item xs={12} sm={12} md={6} lg={4}>
        <TextInput
          multiline
          source="data"
          variant="standard"
          label="Parsed Data"
          rows={7}
          disabled
        />
      </Grid>
      <Grid item xs={12} sm={12} md={6} lg={4}>
        <StyledFileInput
          label="Upload File"
          source="file"
          variant="standard"
          placeholder={
            <span>
              Drag a file here or&nbsp;
              <span className={classes.browseLink}>browse</span>
            </span>
          }
          accept={'.apr, text/plain'}
        >
          <FileField
            source="src"
            title="title"
            size="size"
            type="type"
            download={true}
          />
        </StyledFileInput>
      </Grid>
    </Grid>
  );
};

export default SplitMethodSummary;
